/**
 * logisches exklusives oder
 * @param boolean a
 * @param boolean b
 * @return boolean
 */
export function meinXOR(a: boolean, b: boolean): boolean {
  return !a !== !b;
}
/**
 * prüft ob eine Variable gesetzt ist.
 * @param any theVar zu prüfende Variable
 */
export function isset(theVar: any): boolean {
  return (typeof (theVar) !== 'undefined' || theVar != null);
}
/**
 * rundet eine Zahl auf die angegebene Anzahl an Stellen.
 * @param number Zahl
 * @param number Stellen
 * @return number gerundete Zahl
 */
export function rundeZahl(Zahl: number, Stellen: number = 2): number {
  //  let KV1 = Zahl * Math.pow(10, Stellen);
  //  if (KV1.toString().length - 1 > Zahl.toString().length) {
  //    KV1 += Math.pow(10, (0 - Stellen));
  //  }
  //  return Math.round(KV1) / Math.pow(10, Stellen);

  // Sollte die Anzahl der Stellen 0 oder undefiniert sein geben wir einfach wieder die Zahl zurück
  if (typeof (Stellen) === 'undefined' || +Stellen === 0) {
    return Zahl;
  }
  Zahl = +Zahl;
  Stellen = -Stellen;
  // Falls der zu rundende wert keine Zahl oder die Anzahl der Stellen keine Integer ist gibt es auch keine Zahl zurück!
  if (isNaN(Zahl) || !(typeof (Stellen) === 'number' && Stellen % 1 === 0)) {
    return NaN;
  }
  // Shift
  let zZahl = Zahl.toString().split('e');
  Zahl = Math.round(+(zZahl[0] + 'e' + (zZahl[1] ? (+zZahl[1] - Stellen) : -Stellen)));
  // Shift zurück
  zZahl = Zahl.toString().split('e');
  return +(zZahl[0] + 'e' + (zZahl[1] ? (+zZahl[1] + Stellen) : Stellen));
}
/**
 * wandelt in einem String alle Kommata in Punkte um
 * @param string zu konvertierender String
 * @return string konvertierter String
 */
export function kommaInPunkt(wert: string): string {
  return wert.replace(',', '.');
}
/**
 * wandelt einen Winkel wert in Winkelmaß um
 * @param number degrees Winkel in Grad
 * @return number Winkel in Radians
 */
export function deg2rad(degrees: number): number {
  return degrees * Math.PI / 180;
}
/**
 * wandelt vom Bogenmaß in grad um
 * @param number radians Wert im Bogenmaß
 * @return number Wert in grad
 */
export function rad2deg(radians: number): number {
  return radians * 180 / Math.PI;
}
/**
 * räumt ein Array auf
 * Alle doppelt vorkommenden Einträge werden entfernt.
 * @param any[] eingangsArray Array das aufgeräumt werden soll
 * @return any[]
 */
export function arrayUnique(eingangsArray: any[]): any[] {
  const temp = {};
  const retArray = [];
  for (const wert of eingangsArray) {
    temp[wert] = true;
  }
  for (const wert in temp) {
    if (temp.hasOwnProperty(wert)) {
      retArray.push(wert);
    }
  }
  return retArray;
}
export function holeUhrzeit() {
    const timestamp = new Date();
    return timestamp.getHours() + ':' + timestamp.getMinutes() + ':' + timestamp.getSeconds();
  }
// (function() {
//  /**
//   * Decimal adjustment of a number.
//   *
//   * @param {String}  type  The type of adjustment.
//   * @param {Number}  value The number.
//   * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
//   * @returns {Number} The adjusted value.
//   */
//  function decimalAdjust(type, value, exp) {
//    // If the exp is undefined or zero...
//    if (typeof exp === 'undefined' || +exp === 0) {
//      return Math[type](value);
//    }
//    value = +value;
//    exp = +exp;
//    // If the value is not a number or the exp is not an integer...
//    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
//      return NaN;
//    }
//    // Shift
//    value = value.toString().split('e');
//    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
//    // Shift back
//    value = value.toString().split('e');
//    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
//  }
//
//  // Decimal round
//  if (!Math.round10) {
//    Math.round10 = function(value, exp) {
//      return decimalAdjust('round', value, exp);
//    };
//  }
//  // Decimal floor
//  if (!Math.floor10) {
//    Math.floor10 = function(value, exp) {
//      return decimalAdjust('floor', value, exp);
//    };
//  }
//  // Decimal ceil
//  if (!Math.ceil10) {
//    Math.ceil10 = function(value, exp) {
//      return decimalAdjust('ceil', value, exp);
//    };
//  }
// })();
